import { render, staticRenderFns } from "./aLteFooter.vue?vue&type=template&id=e8413ac8&functional=true"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dem/Go/src/github.com/demget/quadroclub/web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('e8413ac8', component.options)
    } else {
      api.rerender('e8413ac8', component.options)
    }
    module.hot.accept("./aLteFooter.vue?vue&type=template&id=e8413ac8&functional=true", function () {
      api.rerender('e8413ac8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout/aLteFooter.vue"
export default component.exports